import PropTypes from 'prop-types';
import { useParams, useNavigate } from 'react-router';
import { CheckCircleIcon, LockClosedIcon } from '@heroicons/react/24/outline';
import PathwaysIcon from '@/assets/react-icons/md/PathwaysIcon.svg';
import PathwayActionsDropdown from './PathwayActionsDropdown';
import { usePathways } from '@/stores/resourcesStore';
import useIsAdmin from '@/hooks/useIsAdmin';
import ListHeader from '../core/ListHeader';
import ListItemLink from '../core/ListItemLink';
import { isPathwaySucceeded } from '@/utils/pathwayUtils';
import featureConfig from '@/featureConfig';

const PathwayList = () => {
  const pathways = usePathways();
  const { projectId } = useParams();
  const navigate = useNavigate();
  const addNew = event => {
    event.stopPropagation();
    navigate(`/projects/${projectId}/build/pathways/new`);
  };

  const isAdmin = useIsAdmin();

  return (
    <div className="divide-y divide-gray-75">
      <ListHeader onAdd={featureConfig.enablePathwayAdding ? addNew : undefined} title="Pathways" icon={PathwaysIcon} />
      {pathways.length > 0 && (
        <ul className="p-2">
          {pathways.map(pathway => (
            <li key={pathway.id} className="group/item relative">
              <ListItemLink to={`/projects/${projectId}/build/pathways/${pathway.id}/${pathway.case_id}`}>
                <span className="truncate">{pathway.name}</span>
                <div className="group-hover/item:hidden flex gap-2">
                  {pathway.locked && <LockClosedIcon className="text-gray-500 h-4 w-4" />}
                  {isPathwaySucceeded(pathway) && <CheckCircleIcon className="text-green-500 h-4 w-4" />}
                </div>
                {featureConfig.managePathways && (
                  <div className="group-hover/item:flex absolute right-5 hidden bg-canvas">
                    <PathwayActionsDropdown pathway={pathway} isAdmin={isAdmin} />
                  </div>
                )}
              </ListItemLink>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

PathwayList.propTypes = {
  project: PropTypes.object,
};

export default PathwayList;
